/**
 * Slideshow slide — lazy media reveal.
 * On the first user interaction (scroll, pointer move, or touch) on the
 * page, swap each `<video class="slide__video_box"><source data-src>`
 * to its real source and start playback. The defer is to avoid loading
 * media bandwidth before the user has shown any intent to engage.
 *
 * Originally inline in blocks/_slide.liquid.
 */
(function () {
  let revealed = false;

  function revealMedia() {
    if (revealed) return;
    revealed = true;

    document.querySelectorAll('video.slide__video_box').forEach((video) => {
      const source = video.querySelector('source');
      if (source && source.dataset.src) {
        source.src = source.dataset.src;
        video.load();
        video.play().catch(() => {});
      }
    });

    document.removeEventListener('scroll', revealMedia);
    document.removeEventListener('mousemove', revealMedia);
    document.removeEventListener('touchstart', revealMedia);
  }

  document.addEventListener('scroll', revealMedia, { passive: true });
  document.addEventListener('mousemove', revealMedia, { passive: true });
  document.addEventListener('touchstart', revealMedia, { passive: true });
})();
